var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1658 6.43429C13.4782 6.74671 13.4782 7.25324 13.1658 7.56566L7.56578 13.1657C7.25336 13.4781 6.74683 13.4781 6.43441 13.1657L0.834412 7.56566C0.678178 7.40943 0.600073 7.20465 0.600098 6.99988V2.99998C0.600098 1.67449 1.67461 0.599976 3.0001 0.599976H7.00032C7.20498 0.600031 7.40963 0.678136 7.56578 0.83429L13.1658 6.43429ZM3.0001 3.79998C3.44193 3.79998 3.8001 3.4418 3.8001 2.99998C3.8001 2.55815 3.44193 2.19998 3.0001 2.19998C2.55827 2.19998 2.2001 2.55815 2.2001 2.99998C2.2001 3.4418 2.55827 3.79998 3.0001 3.79998Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.4ca72dc1de6df11d9286b5514401b23a.svg";
export { ForwardRef as ReactComponent };